import { http } from '@/shared/api/api-client';

import type { Dashboard } from '../types/dashboard.types';

/**
 * Dashboard — GET /admin/dashboard (dashboard.read).
 *
 * UT system/AdminApis/Operations/Controllers/AdminOperationsControllers.cs.
 * The backend filters to the staff member's countries and leaves out what
 * they may not see: revenue without reports.financial.read, and each
 * attention count without the matching permission (null).
 */

export interface DashboardParams {
  from: string;
  to: string;
  countryId?: number;
}

export async function getDashboard(
  params: DashboardParams,
  signal?: AbortSignal,
): Promise<Dashboard> {
  return http.get<Dashboard>('/admin/dashboard', { params, signal });
}
